import React from "react";
import { Helmet } from "react-helmet-async";


export default function SEO(
  {
    title = "Séculos Engenharia e Serviços LTDA",
    description = "Responsabilidade Socioambiental, Compromisso, Qualidade e Confiança.",
    type = "website",
    link = "https://seculosengenharia.com.br",
    linkedinImage = "https://seculosengenharia.com.br/files/capa.jpg",
    keywords = "empresa de engenharia em Parauapebas, engenharia, engenharia civil, engenharia Parauapebas, serviços de engenharia, construção civil, Vale, OZ Minerals",
  }
) {
  return(
    <Helmet>
      <title>{title}</title>
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={linkedinImage} />
      <link rel="canonical" href={link} />
      <meta httpEquiv="Content-Language" content="pt-BR" />
    </Helmet>
  )
}